import PhotoGrid from './PhotoGrid';

export default PhotoGrid;
